import $ from "jquery";
import { getCookie, setCookie } from "../lib/cookies";
import { showModal, isAnyModalOpen } from "./modal-manager";

$(() => {
  if (window.skipexternal) {
    return;
  }

  const contraveajaxurl = location.search
    ? contravemain.ajax_url + location.search
    : contravemain.ajax_url;

  console.log(contraveajaxurl);

  $.ajax({
    type: "POST",
    url: contraveajaxurl,
    data: {
      action: "set_cx_hash",
    },
    success(response) {
      const data = JSON.parse(response);

      if (data.country !== "US") {
        const acceptedRestrictions = getCookie("acceptedRestrictions");

        if (acceptedRestrictions !== "true") {
          if (!isAnyModalOpen()) {
            if (data.country === "CA") {
              showModal("#modal_canada");
            } else {
              showModal("#modal_international");
            }
          }
          const modalSelector = data.country === "CA" ? "#modal_canada" : "#modal_international";
          $(modalSelector).on("hidden.bs.modal", () => {
            setCookie("acceptedRestrictions", "true", 1);
          });
        }
      }
    },
  });
});
